import { toHTML } from "@portabletext/to-html";
import { CarouselInlineCaptionProps } from "@bluebottlecoffee/design-system/components";
import { CarouselInlineCaption as Schema } from "../sanity-schema";
import { toLinkProps } from "./link";
import { toImageResponsiveWithCaptionProps } from "./image";
import { trackEvent } from "../segment/track-event";
import { isHomePage, stripHtmlTags } from "../utils";

export function toCarouselInlineCaptionProps(
  data: Schema,
  region: string,
  lang: string,
): CarouselInlineCaptionProps {
  const parsedHeadline = data?.heading ? toHTML(data.heading[lang]) : "";
  return {
    ...(data.bgColor && { bgColor: data.bgColor }),
    ...(data.cta?.text && {
      cta: {
        ...toLinkProps(data.cta, region, lang),
        onClick: () => {
          if (isHomePage(lang, region)) {
            trackEvent("homepage_cta", {
              heading:
                stripHtmlTags(parsedHeadline) || "Carousel Inline Caption",
              cta_name: data.cta.text[lang],
            });
          }
        },
      },
    }),
    ...(data.heading && {
      heading: parsedHeadline,
    }),
    ...(data.textAlign && { textAlign: data.textAlign }),
    ...(data.description && { description: toHTML(data.description[lang]) }),
    title: data.title[lang],
    images: data.images.map((i) => toImageResponsiveWithCaptionProps(i, lang)),
  };
}
